function DocumentIcon() {
  return (
    <svg
      width="37"
      height="41"
      viewBox="0 0 37 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.3499 0.277344H7.52594C6.18194 0.277344 5.08594 1.36534 5.08594 2.71734V37.8373C5.08594 39.1813 6.17394 40.2773 7.52594 40.2773H33.6619C35.0059 40.2773 36.1019 39.1893 36.1019 37.8373V8.37334L25.3499 0.277344Z"
        fill="#F3F4F6"
        stroke="#D1D5DB"
      />
      <path
        d="M26.846 8.42116L36.102 8.37316L25.382 0.285156L25.334 7.28516C25.334 7.88516 26.174 8.42116 26.846 8.42116Z"
        fill="#D1D5DB"
      />
      <path
        d="M18.072 18.3423H2.624C1.176 18.3423 0 17.1663 0 15.7183V11.5263C0 10.0783 1.176 8.90234 2.624 8.90234H18.072C19.52 8.90234 20.696 10.0783 20.696 11.5263V15.7183C20.688 17.1663 19.52 18.3423 18.072 18.3423Z"
        fill="#0088FF"
      />
      <path
        d="M6.60631 14.9989C6.38231 15.4069 6.05431 15.7349 5.62231 15.9589C5.19831 16.1909 4.69431 16.3029 4.11831 16.3029H2.07031V10.8789H4.11831C4.70231 10.8789 5.20631 10.9909 5.63031 11.2149C6.05431 11.4389 6.38231 11.7589 6.60631 12.1669C6.83031 12.5749 6.95031 13.0469 6.95031 13.5749C6.95031 14.1189 6.83831 14.5909 6.60631 14.9989ZM5.19831 14.7269C5.47831 14.4549 5.62231 14.0789 5.62231 13.5829C5.62231 13.0949 5.47831 12.7109 5.19831 12.4389C4.91831 12.1669 4.51831 12.0309 4.00631 12.0309H3.38231V15.1269H4.00631C4.51831 15.1349 4.91831 14.9989 5.19831 14.7269Z"
        fill="#F3F4F6"
      />
      <path
        d="M11.6616 11.1569C12.0776 11.3969 12.4056 11.7249 12.6456 12.1489C12.8856 12.5729 13.0056 13.0449 13.0056 13.5809C13.0056 14.1089 12.8856 14.5889 12.6376 15.0129C12.3976 15.4369 12.0616 15.7649 11.6456 16.0049C11.2296 16.2449 10.7656 16.3649 10.2616 16.3649C9.75758 16.3649 9.29358 16.2449 8.87758 16.0049C8.46158 15.7649 8.13358 15.4369 7.88558 15.0129C7.64558 14.5889 7.51758 14.1089 7.51758 13.5809C7.51758 13.0529 7.63758 12.5729 7.88558 12.1489C8.13358 11.7249 8.46158 11.3969 8.87758 11.1569C9.29358 10.9169 9.75758 10.7969 10.2616 10.7969C10.7816 10.8049 11.2456 10.9249 11.6616 11.1569ZM9.24558 12.4369C8.98958 12.7169 8.86958 13.0929 8.86958 13.5729C8.86958 14.0449 8.99758 14.4289 9.24558 14.7089C9.50158 14.9889 9.83758 15.1329 10.2696 15.1329C10.6936 15.1329 11.0376 14.9889 11.2856 14.7089C11.5416 14.4289 11.6696 14.0529 11.6696 13.5729C11.6696 13.0929 11.5416 12.7169 11.2936 12.4369C11.0376 12.1569 10.7016 12.0129 10.2696 12.0129C9.83758 12.0209 9.50158 12.1569 9.24558 12.4369Z"
        fill="#F3F4F6"
      />
      <path
        d="M17.934 11.3799C18.39 11.7399 18.678 12.2359 18.814 12.8519H17.43C17.326 12.6039 17.174 12.4039 16.958 12.2599C16.742 12.1159 16.494 12.0439 16.206 12.0439C15.822 12.0439 15.51 12.1879 15.278 12.4679C15.046 12.7479 14.926 13.1239 14.926 13.5959C14.926 14.0679 15.046 14.4439 15.278 14.7159C15.51 14.9959 15.822 15.1319 16.206 15.1319C16.494 15.1319 16.75 15.0599 16.958 14.9159C17.174 14.7719 17.326 14.5799 17.43 14.3319H18.814C18.678 14.9479 18.39 15.4359 17.934 15.8039C17.478 16.1719 16.91 16.3559 16.222 16.3559C15.694 16.3559 15.23 16.2359 14.838 16.0039C14.438 15.7719 14.134 15.4439 13.91 15.0279C13.694 14.6119 13.582 14.1319 13.582 13.5959C13.582 13.0599 13.694 12.5799 13.91 12.1639C14.126 11.7479 14.438 11.4199 14.838 11.1879C15.238 10.9559 15.702 10.8359 16.222 10.8359C16.91 10.8359 17.486 11.0119 17.934 11.3799Z"
        fill="#F3F4F6"
      />
      <path
        d="M33.3381 26.0234H15.5781V27.0474H33.3381V26.0234Z"
        fill="#D1D5DB"
      />
      <path
        d="M33.3303 29.4453H7.98633V30.4693H33.3303V29.4453Z"
        fill="#D1D5DB"
      />
      <path
        d="M25.3377 32.8789H7.92969V33.9029H25.3377V32.8789Z"
        fill="#D1D5DB"
      />
      <path
        d="M14.968 22.0938L13.68 27.2617H12.656L11.568 23.2697L10.48 27.2617H9.45597L8.16797 22.1017H9.07997L9.97597 26.3017L11.112 22.1017H12.032L13.168 26.3017L14.064 22.1017H14.968V22.0938Z"
        fill="#D1D5DB"
      />
    </svg>
  );
}

export default DocumentIcon;
